import Vue from 'vue';
import App from './App.vue';
import CashflowCalculator from './Components/CashflowCalculator.vue';
import CashflowCalculations from './store/CashflowCalculations';

import './../node_modules/jquery/dist/jquery.min.js';
import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './../node_modules/bootstrap/dist/js/bootstrap.min.js';

import Suggestions from 'v-suggestions';
import 'v-suggestions/dist/v-suggestions.css';

import VueRouter from 'vue-router';

Vue.use(Suggestions);
Vue.use(VueRouter);

const routes = [];

const router = new VueRouter({
    routes,
    mode: 'history'
});

new Vue({
    store: CashflowCalculations,
    el: '#cashflow-calculator',
    router,
    render: h => h(CashflowCalculator)
})


// WEBPACK FOOTER //
// ./src/main.js